module.exports = __webpack_public_path__ + "static/media/worldwideIcon.6500554f.svg";